<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    class="block h-5 w-5 shrink-0"
    aria-hidden="true"
    :style="iconColorStyle"
  >
    <path
      d="M17.5001 13.75V16.6667C17.5001 17.1269 17.127 17.5 16.6667 17.5H15.0001C14.5398 17.5 14.1667 17.1269 14.1667 16.6667V15.4167"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M5.83333 15.4167V16.6667C5.83333 17.1269 5.46024 17.5 5 17.5H3.33333C2.8731 17.5 2.5 17.1269 2.5 16.6667V13.75"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M2.5 13.75V11.4545C2.5 10.7909 2.76347 10.1545 3.2325 9.685L4.16667 8.75H15.8333L16.7675 9.68417C17.2365 10.1532 17.5 10.7893 17.5 11.4526V13.75C17.5 14.6705 16.7538 15.4167 15.8333 15.4167H4.16667C3.24619 15.4167 2.5 14.6705 2.5 13.75Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M17.4999 7.91683L15.8333 8.3335"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M4.16667 8.3335L2.5 7.91683"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M4.16675 8.74984V8.32817L4.86341 5.714C5.10659 4.80147 5.93295 4.16649 6.87733 4.1665H13.1962C14.1606 4.1665 14.9989 4.82842 15.2226 5.7665L15.8334 8.32817V8.74984"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M5 12.0832H6.66667"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M13.3333 12.0832H14.9999"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps<{
  active?: boolean
  /** Cor dos traços (ex.: #585B79 inativo, #FFFFFF ativo no tab slider). */
  color?: string
}>()

const iconColorStyle = computed(() =>
  props.color != null && props.color !== '' ? { color: props.color } : undefined,
)
</script>
